import { API_ROOT } from '../constants'
import api from '../utils/api'

export const deleteDomain = (data, config) => api.post(`${API_ROOT}/v3/custom-domain/delete`, data, config)

export const clearDomainCache = (data, config) => api.post(`${API_ROOT}/v3/custom-domain/clear-cache`, data, config)

export const autoConnectDomainAdd = (data, config) => api.post(`${API_ROOT}/v3/custom-domain/add`, data, config)

export const autoConnectDomainFinish = (data, config) => api.post(`${API_ROOT}/v3/custom-domain/validate`, data, config)

export const autoConnectDomainFailed = (data, config) => api.post(`${API_ROOT}/v3/custom-domain/failed`, data, config)

export const autoConnectDomainRetry = (data, config) => api.post(`${API_ROOT}/v3/custom-domain/retry`, data, config)

export const getAvailableDomains = (data, config) => api.get(`${API_ROOT}/v3/custom-domain/buy/search`, data, config)

export const purchaseDomain = (data, config) => api.get(`${API_ROOT}/v3/custom-domain/buy/purchase`, data, config)

export const checkDomain = (data, config) => api.get(`${API_ROOT}/v3/custom-domain/buy/check`, data, config)

export const makeEnomStripePayment = (data, config) =>
  api.post(`${API_ROOT}/v3/custom-domain/stripe-enom-payment`, data, config)

export const setUpPassword = (data, config) => api.post(`${API_ROOT}/v3/custom-domain/manage-dns`, data, config)

export const publishSiteToCustomDomain = (data, config) =>
  api.post(`${API_ROOT}/v3/site/update?domain=${data.currentSiteDomain}`, data.formData, config)

export const addWasmerDomainRecord = (data, config) => api.post(`${API_ROOT}/v3/custom-domain/wasmer`, data, config)

export const updateAutoRenew = (data, config) =>
  api.post(`${API_ROOT}/v3/custom-domain/update-auto-renew`, data, config)

export const fetchNameServers = async (domain) => {
  try {
    const response = await fetch(`https://dns.google/resolve?name=${encodeURIComponent(domain)}&type=NS`)
    const data = await response.json()
    if (data && data.Answer) {
      return data.Answer.filter((record) => record.type === 2).map((record) => record.data)
    }
    return []
  } catch (error) {
    console.error('Failed to fetch name servers:', error)
    return []
  }
}
